import { NetworkState, State } from 'types';

export default {
  getNetwork: (state: State): NetworkState => state.network,
};
